module.exports = __webpack_public_path__ + "img/sales.753963cc.svg";